import ApiClient from "@/api/ApiClient.ts";
import { NEW_NOTIFICATION } from "@/events/constants";
import { NOTIFICATION_TYPE_ZONES_ERRORS } from "@/utils/constants";

const state = {
  stopszones: [],
  stopZoneToEdit: {},
  currentZoom: 0,
  currentCenter: {},
};

const mutations = {
  setStopsZones(state, stopszones) {
    state.stopszones = stopszones;
  },

  setStopZoneToEdit(state, stopzone) {
    state.stopZoneToEdit = { ...stopzone };
  },

  setPolygonStopZoneToEdit(state, polygon) {
    state.stopZoneToEdit.polygon = polygon;
  },

  setCurrentZoom(state, zoom) {
    state.currentZoom = zoom;
  },

  setCurrentCenter(state, center) {
    state.currentCenter = center;
  },
};

const actions = {
  async getStopsZones({ commit }, payload) {
    let params = {};
    if (payload) {
      params = {
        wgId: payload.params.wgId,
        idWg: payload.params.idWg,
        centralId: payload.params.centralId,
      };
    }
    try {
      let response = await ApiClient().get("stopszones", { params });
      let reverseLatLngs = response.data.map((item) => {
        if (item.polygon) {
          let newPolygon = [];
          item.polygon.forEach((point) => {
            newPolygon.push(point.reverse());
          });
          item.polygon = newPolygon;
        }
        if (item.enterPolygon) {
          let newPolygon = [];
          item.enterPolygon.forEach((point) => {
            newPolygon.push(point.reverse());
          });
          item.enterPolygon = newPolygon;
        }
        if (item.exitPolygon) {
          let newPolygon = [];
          item.exitPolygon.forEach((point) => {
            newPolygon.push(point.reverse());
          });
          item.exitPolygon = newPolygon;
        }
        if (item.head) {
          item.head = item.head.reverse();
        }

        return item;
      });

      commit("setStopsZones", reverseLatLngs);
    } catch (error) {
      console.error("ERROR en getStopsZones: ", error.message);
    }
  },

  async updateStop(_, payload) {
    const { params, data } = payload;
    try {
      await ApiClient().put("stops/stops2", data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateStop: ", error.message);
      return false;
    }
  },

  async createStop(_, payload) {
    const { params, data } = payload;
    try {
      await ApiClient().post("stops/stops2", data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en createZone: ", error.message);
      return false;
    }
  },

  async updateZone(_, payload) {
    const { params, data } = payload;
    try {
      await ApiClient().put("zones/zones2", data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateZone: ", error.message);
      return false;
    }
  },

  async createZone(_, payload) {
    const { params, data } = payload;
    try {
      await ApiClient().post("zones/zones2", data, {
        params,
        headers: { "content-type": "application/json" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en createZone: ", error.message);
      return false;
    }
  },

  async deleteZone(_, payload) {
    const { params } = payload;
    try {
      await ApiClient().delete("zones", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR on deleteZone: ", error.message);
      return false;
    }
  },

  async deleteStop(_, payload) {
    const { params } = payload;
    try {
      await ApiClient().delete("stops", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR on deleteStop: ", error.message);
      return false;
    }
  },

  getStopZone({ getters }, ref) {
    return getters.stopszones.find((i) => i.ref === ref);
  },

  /**
   *
   * @param {Number[]} workgroups
   */
  async checkStopsErrors(_, workgroups) {
    let zonesErrorsCount = 0;
    for (const wg of workgroups) {
      const { data } = await ApiClient().get("stopszones", {
        params: {
          wgId: wg,
        },
      });
      zonesErrorsCount += data.filter((i) => i.head && !i.data.defaultDeliveryId).length;
    }

    if (zonesErrorsCount > 0) {
      window.$bus.emit(NEW_NOTIFICATION, {
        type: NOTIFICATION_TYPE_ZONES_ERRORS,
        inserted: Date.now(),
      });
    }
  },
};

const getters = {
  stopszones(state) {
    return state.stopszones;
  },

  stops(state) {
    if (state.stopszones) {
      let stops = state.stopszones.filter((item) => !item.polygon);
      return stops;
    }
  },

  zones(state) {
    if (state.stopszones) {
      let zones = state.stopszones.filter((item) => item.polygon);
      return zones;
    }
  },

  segmentsWithoutStopZoneToEdit(state) {
    if (state.stopszones) {
      let segments = [];
      let zones = state.stopszones.filter(
        (item) => state.stopZoneToEdit.ref !== item.ref && item.polygon
      );
      zones.forEach((zone) => {
        segments.push(convertToSegments(zone.polygon));
      });
      return segments.flat();
    }
  },

  stopZoneToEdit(state) {
    return state.stopZoneToEdit;
  },

  currentZoom(state) {
    return state.currentZoom;
  },

  currentCenter(state) {
    return state.currentCenter;
  },
};

function convertToSegments(geo) {
  const output = [];
  for (let i = 0; i < geo.length - 1; i++) {
    output.push([geo[i], geo[i + 1]]);
  }
  return output;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
